import { useBox } from "@react-three/cannon";
import { THICKNESS, Y } from "./shared";

export default function PhysicsBoxes() {
	const [backLeftRef] = useBox(() => ({
		type: "Static" as const,
		args: [6.5, THICKNESS, 22],
		position: [-4.75, Y, -9],
	}));
	const [backRightRef] = useBox(() => ({
		type: "Static" as const,
		args: [6.5, THICKNESS, 22],
		position: [4.75, Y, -9],
	}));
	const [centerRef] = useBox(() => ({
		type: "Static" as const,
		args: [3, THICKNESS, 22],
		position: [0, Y, -9],
	}));
	const [leftRef] = useBox(() => ({
		type: "Static" as const,
		args: [7, THICKNESS, 35],
		position: [-11.5, Y, -2.5],
	}));
	const [rightRef] = useBox(() => ({
		type: "Static" as const,
		args: [7, THICKNESS, 35],
		position: [11.5, Y, -2.5],
	}));

	// ── Glass railing colliders ────────────────────────────────────────────────
	// Outer left glass wall (from [-15, -20] to [-15, 12])
	const [glassOuterLeftRef] = useBox(() => ({
		type: "Static" as const,
		args: [0.2, 1.5, 32],
		position: [-15, Y + THICKNESS + 0.75, -4],
	}));

	// Outer bottom glass wall (from [-15, -20] to [15, -20])
	const [glassOuterBottomRef] = useBox(() => ({
		type: "Static" as const,
		args: [30, 1.5, 0.2],
		position: [0, Y + THICKNESS + 0.75, -20],
	}));

	// Outer right glass wall (from [15, -20] to [15, 12])
	const [glassOuterRightRef] = useBox(() => ({
		type: "Static" as const,
		args: [0.2, 1.5, 32],
		position: [15, Y + THICKNESS + 0.75, -4],
	}));

	// Inner left glass wall (from [-8, 2] to [-8, 12])
	const [glassInnerLeftRef] = useBox(() => ({
		type: "Static" as const,
		args: [0.2, 1.5, 10],
		position: [-8, Y + THICKNESS + 0.75, 7],
	}));

	// Inner right glass wall (from [8, 2] to [8, 12])
	const [glassInnerRightRef] = useBox(() => ({
		type: "Static" as const,
		args: [0.2, 1.5, 10],
		position: [8, Y + THICKNESS + 0.75, 7],
	}));

	// Inner bottom glass wall (from [-8, 2] to [8, 2])
	const [glassInnerBottomRef] = useBox(() => ({
		type: "Static" as const,
		args: [16, 1.5, 0.2],
		position: [0, Y + THICKNESS + 0.75, 2],
	}));

	// ── Additional corner colliders to prevent clipping ────────────────────────
	// Outer top left corner (from [-15, 12] to [-8, 12])
	const [outerTopLeftCornerRef] = useBox(() => ({
		type: "Static" as const,
		args: [7, 1.5, 0.2],
		position: [-11.5, Y + THICKNESS + 0.75, 12],
	}));

	// Outer top right corner (from [8, 12] to [15, 12])
	const [outerTopRightCornerRef] = useBox(() => ({
		type: "Static" as const,
		args: [7, 1.5, 0.2],
		position: [11.5, Y + THICKNESS + 0.75, 12],
	}));

	// Inner top left corner (from [-8, 12] to [-8, 2])
	const [innerTopLeftCornerRef] = useBox(() => ({
		type: "Static" as const,
		args: [0.2, 1.5, 10],
		position: [-8, Y + THICKNESS + 0.75, 7],
	}));

	// Inner top right corner (from [8, 12] to [8, 2])
	const [innerTopRightCornerRef] = useBox(() => ({
		type: "Static" as const,
		args: [0.2, 1.5, 10],
		position: [8, Y + THICKNESS + 0.75, 7],
	}));

	return (
		<>
			<mesh ref={backLeftRef} visible={false} />
			<mesh ref={backRightRef} visible={false} />
			<mesh ref={centerRef} visible={false} />
			<mesh ref={leftRef} visible={false} />
			<mesh ref={rightRef} visible={false} />
			{/* Glass railing colliders */}
			<mesh ref={glassOuterLeftRef} visible={false} />
			<mesh ref={glassOuterBottomRef} visible={false} />
			<mesh ref={glassOuterRightRef} visible={false} />
			<mesh ref={glassInnerLeftRef} visible={false} />
			<mesh ref={glassInnerRightRef} visible={false} />
			<mesh ref={glassInnerBottomRef} visible={false} />
			{/* Corner colliders */}
			<mesh ref={outerTopLeftCornerRef} visible={false} />
			<mesh ref={outerTopRightCornerRef} visible={false} />
			<mesh ref={innerTopLeftCornerRef} visible={false} />
			<mesh ref={innerTopRightCornerRef} visible={false} />
		</>
	);
}
